module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2017-01-06",
		"endpointPrefix": "cur",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "AWS Cost and Usage Report Service",
		"signatureVersion": "v4",
		"signingName": "cur",
		"targetPrefix": "AWSOrigamiServiceGatewayService",
		"uid": "cur-2017-01-06"
	},
	"operations": {
		"DeleteReportDefinition": {
			"input": {
				"type": "structure",
				"members": {
					"ReportName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ResponseMessage": {}
				}
			}
		},
		"DescribeReportDefinitions": {
			"input": {
				"type": "structure",
				"members": {
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReportDefinitions": {
						"type": "list",
						"member": {
							"shape": "Sa"
						}
					},
					"NextToken": {}
				}
			}
		},
		"PutReportDefinition": {
			"input": {
				"type": "structure",
				"required": [
					"ReportDefinition"
				],
				"members": {
					"ReportDefinition": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		}
	},
	"shapes": {
		"Sa": {
			"type": "structure",
			"required": [
				"ReportName",
				"TimeUnit",
				"Format",
				"Compression",
				"AdditionalSchemaElements",
				"S3Bucket",
				"S3Prefix",
				"S3Region"
			],
			"members": {
				"ReportName": {},
				"TimeUnit": {},
				"Format": {},
				"Compression": {},
				"AdditionalSchemaElements": {
					"type": "list",
					"member": {}
				},
				"S3Bucket": {},
				"S3Prefix": {},
				"S3Region": {},
				"AdditionalArtifacts": {
					"type": "list",
					"member": {}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/cur-2017-01-06.min.json
// module id = 379
// module chunks = 0